import { PaymentMethod } from '../enums/paymentMethod';
import { transformEnumToOptions } from '1_shared';

export const paymentMethodOptions = transformEnumToOptions(PaymentMethod);